export default __webpack_public_path__ + "static/Rubicon-floor-scrubber-icon-thick-5ac5f7b864c2462e6557c71d0af089e7.png";